import { ArrowLeftRight, BadgeEuro, BellRing, Boxes, Cable, Calculator, ChartColumnBig, ClipboardCheck, ClipboardList, Contact, Factory, FileText, FolderKanban, Gauge, History, House, Kanban, Landmark, ListChecks, MapPin, MessageSquareText, PackageSearch, Ruler, Scale, ScanLine, ScrollText, ShieldAlert, ShieldCheck, ShoppingCart, SlidersHorizontal, Tag, TrendingUp, Truck, UserRound, UsersRound, Warehouse, Wrench, Layers3, CalendarClock, CalendarRange, Activity } from "lucide-react";

const quotingNavigation = [
  { to: "/preventivi", label: "Preventivi", icon: Calculator, permission: "quotes:view", module: "preventivazione" },
  { to: "/preventivi/impostazioni", label: "Impostazioni preventivi", icon: SlidersHorizontal, permission: "quotes:costs:view", module: "preventivazione" },
];

const qualityNavigation = [
  { to: "/qualita/dashboard", label: "Dashboard qualità", icon: Gauge, permission: "quality:view", module: "qualita" },
  { to: "/qualita/procedure", label: "Procedure", icon: ClipboardCheck, permission: "quality:view", module: "qualita" },
  { to: "/qualita/piani-controllo", label: "Piani di controllo", icon: Layers3, permission: "quality:view", module: "qualita" },
  { to: "/qualita/controlli", label: "Controlli eseguiti", icon: ClipboardCheck, permission: "quality:view", module: "qualita" },
  { to: "/qualita/non-conformita", label: "Non conformità", icon: ShieldAlert, permission: "quality:view", module: "qualita" },
  { to: "/qualita/azioni-correttive", label: "Azioni correttive", icon: ListChecks, permission: "quality:view", module: "qualita" },
  { to: "/qualita/strumenti", label: "Strumenti di misura", icon: Wrench, permission: "quality:view", module: "qualita" },
  { to: "/qualita/report-direzione", label: "Report direzione", icon: FileText, permission: "quality:view", module: "qualita" },
  { to: "/qualita/audit", label: "Audit log", icon: ScrollText, permission: "quality:audit:view", module: "qualita" },
];

const controllingNavigation = [
  { to: "/sedi", label: "Sedi aziendali", icon: MapPin, permission: "sites:view", module: "amministrazione" },
  { to: "/clienti", label: "Clienti", icon: Contact, permission: "customers:view", module: "amministrazione" },
  { to: "/controllo/produzione", label: "Report produzione", icon: Factory, permission: "controlling:view", module: "produzione" },
  { to: "/controllo/dashboard", label: "Dashboard direzionale", icon: TrendingUp, permission: "controlling:view", module: "controllo_gestione" },
  { to: "/controllo/marginalita", label: "Report marginalità ordini cliente", icon: BadgeEuro, permission: "controlling:view", module: "controllo_gestione" },
  { to: "/controllo/clienti", label: "Report clienti", icon: Contact, permission: "controlling:view", module: "controllo_gestione" },
  { to: "/controllo/qualita", label: "Report qualità", icon: ShieldAlert, permission: "controlling:view", module: "controllo_gestione" },
  { to: "/controllo/prezzi", label: "Prezzi di vendita ordini cliente", icon: Tag, permission: "controlling:view", anyPermission: ["controlling:revenue:view", "controlling:margin:view", "quotes:costs:view"], module: "controllo_gestione" },
  { to: "/controllo/configurazione", label: "Configurazione costi e obiettivi", icon: SlidersHorizontal, permission: "controlling:rates:view", module: "controllo_gestione" },
];

export const modules = [
  {
    label: "Amministrazione & Controllo",
    icon: Scale,
    items: controllingNavigation,
  },
  {
    label: "Logistica generale e utensili",
    icon: Warehouse,
    items: [
      { to: "/quadro-utensili", label: "Quadro utensili", icon: House, permission: "dashboard:view", module: "logistica" },
      { to: "/utensili", label: "Catalogo utensili", icon: Wrench, permission: "catalog:view", module: "logistica" },
      { to: "/attacchi-base", label: "Catalogo attacchi base", icon: Cable, permission: "catalog:view", module: "logistica" },
      { to: "/inventario", label: "Inventario", icon: Boxes, permission: "inventory:view", module: "logistica" },
      { to: "/formati-grezzo", label: "Formati grezzo", icon: Ruler, permission: "inventory:view", module: "logistica" },
      { to: "/magazzini", label: "Magazzini", icon: Warehouse, permission: "inventory:view", module: "logistica" },
      { to: "/semilavorati", label: "Semilavorati e cartellini", icon: Layers3, permission: "inventory:view", module: "logistica" },
      { to: "/attrezzature-staffaggio", label: "Attrezzature di staffaggio", icon: Wrench, permission: "inventory:view", module: "logistica" },
      { to: "/attrezzature-staffaggio/assegnazione", label: "Attrezzature sulle fasi", icon: Wrench, permission: "parts:view", module: "logistica" },
      { to: "/movimenti", label: "Movimenti", icon: ArrowLeftRight, permission: "inventory:view", module: "logistica" },
      { to: "/analisi", label: "Consumi e riordini", icon: ChartColumnBig, permission: "inventory:view", module: "logistica" },
      { to: "/consumo-utensili", label: "Consumo utensili (KPI)", icon: Activity, permission: "inventory:view", module: "logistica" },
    ],
  },
  {
    label: "Acquisti & Fornitori",
    icon: ShoppingCart,
    items: [
      { to: "/acquisti/dashboard", label: "Cruscotto acquisti", icon: Gauge, permission: "purchases:view", module: "acquisti" },
      { to: "/acquisti/proposte", label: "Proposte di acquisto", icon: ListChecks, permission: "purchases:view", module: "acquisti" },
      { to: "/acquisti/ordini", label: "Ordini di acquisto", icon: ShoppingCart, permission: "purchases:view", module: "acquisti" },
      { to: "/acquisti/fornitori", label: "Fornitori", icon: Truck, permission: "purchases:view", module: "acquisti" },
      { to: "/acquisti/articoli", label: "Ricambi e consumabili", icon: Boxes, permission: "purchases:view", module: "acquisti" },
    ],
  },
  {
    label: "Produzione",
    icon: Factory,
    items: [
      { to: "/produzione/dashboard", label: "Dashboard produzione", icon: Gauge, permission: "planning:view", module: "produzione" },
      { to: "/macchine", label: "Macchine utensili", icon: Factory, permission: "machines:view", module: "produzione" },
      { to: "/reparti", label: "Reparti e persone", icon: Landmark, permission: "planning:view", module: "produzione" },
      { to: "/turni", label: "Turni di lavoro", icon: CalendarClock, permission: "planning:view", module: "produzione" },
      { to: "/materiali", label: "Materiali", icon: Layers3, permission: "materials:view", module: "produzione" },
      { to: "/componenti", label: "Componenti", icon: PackageSearch, permission: "parts:view", module: "produzione" },
      { to: "/progetti", label: "Progetti / Commesse tecniche", icon: FolderKanban, permission: "planning:view", module: "produzione" },
      { to: "/ordini-cliente", label: "Ordini cliente", icon: ClipboardList, permission: "planning:view", module: "produzione" },
      { to: "/produzione/ordini", label: "Ordini di produzione (OdP)", icon: CalendarClock, permission: "planning:view", module: "produzione" },
      { to: "/produzione/pianificazione", label: "Pianificazione", icon: CalendarRange, permission: "planning:view", module: "produzione" },
      { to: "/produzione/kanban", label: "Kanban produzione", icon: Kanban, permission: "planning:view", module: "produzione" },
      { to: "/produzione/fasi", label: "Fasi (tabella)", icon: ListChecks, permission: "planning:view", module: "produzione" },
      { to: "/produzione/officina", label: "Avanzamento officina", icon: Factory, permission: "planning:execute", module: "produzione" },
      { to: "/officina/scansiona", label: "Scansiona QR", icon: ScanLine, permission: "planning:execute", module: "produzione" },
      { to: "/produzione/lotti", label: "Lotti di produzione", icon: Boxes, permission: "planning:view", module: "produzione" },
      { to: "/consegne", label: "Consegne / DDT", icon: Truck, permission: "planning:view", module: "produzione" },
      { to: "/produzione/report-chiusura", label: "Report chiusura ordini cliente", icon: FileText, permission: "planning:view", module: "produzione" },
      { to: "/produzione/efficienza-fasi", label: "Efficienza fasi", icon: TrendingUp, permission: "planning:view", module: "produzione" },
      { to: "/produzione/storico", label: "Storico attività", icon: History, permission: "planning:view", module: "produzione" },
    ],
  },
  { label: "Qualità", icon: ShieldCheck, items: qualityNavigation },
  { label: "Preventivazione", icon: BadgeEuro, items: quotingNavigation },
];

export const settingsNavigation = [
  { to: "/piano", label: "Piano e limiti", icon: BadgeEuro },
  { to: "/comunicazione", label: "Comunicazione", icon: MessageSquareText },
  { to: "/azienda", label: "Informazioni azienda", icon: Factory },
  { to: "/impostazioni-utente", label: "Impostazioni utente", icon: UserRound },
  { to: "/utenti", label: "Amministrazione utenti", icon: UsersRound, permission: "users:manage" },
  { to: "/sicurezza", label: "Sicurezza", icon: ShieldCheck, permission: "company:manage" },
  { to: "/preferenze-avvisi", label: "Preferenze avvisi", icon: BellRing, permission: "company:manage" },
];

const allNavItems = modules.flatMap((module) => module.items);

const STATIC_TITLES = {
  "/": "Area aziendale",
  "/quadro-utensili": "Quadro utensili",
  "/pezzi": "Componenti",
  "/piano": "Piano e limiti",
  "/super-admin": "Gestione piattaforma",
  "/comunicazione": "Comunicazione",
  "/azienda": "Informazioni azienda",
  "/impostazioni-utente": "Impostazioni utente",
  "/utenti": "Amministrazione utenti",
  "/sicurezza": "Sicurezza",
  "/preferenze-avvisi": "Preferenze avvisi",
  "/produzione/kanban": "Kanban produzione",
  "/produzione/fasi": "Fasi pianificate",
  "/produzione/officina": "Avanzamento officina",
  "/officina/scansiona": "Scansiona QR",
  "/produzione/dashboard": "Dashboard produzione",
  "/produzione/storico": "Storico attività produzione",
  "/produzione/report-chiusura": "Report chiusura ordini",
  "/produzione/ordini": "Ordini di produzione (OdP)",
  "/produzione/lotti": "Lotti di produzione",
  "/ordini-cliente": "Ordini cliente",
  "/progetti": "Progetti / Commesse tecniche",
  "/consegne": "Consegne / DDT",
  "/produzione/efficienza-fasi": "Efficienza fasi",
  "/qualita/procedure": "Procedure qualità",
  "/qualita/piani-controllo": "Piani di controllo",
  "/qualita/dashboard": "Dashboard qualità",
  "/qualita/controlli": "Controlli digitali",
  "/qualita/strumenti": "Strumenti di misura",
  "/qualita/non-conformita": "Non conformità",
  "/qualita/azioni-correttive": "Azioni correttive 8D",
  "/qualita/report-direzione": "Report direzione",
  "/qualita/audit": "Audit log qualità",
  "/preventivi": "Preventivi",
  "/preventivi/impostazioni": "Impostazioni preventivazione",
  "/controllo/configurazione": "Configurazione costi e obiettivi",
  "/controllo/marginalita": "Report marginalità ordini cliente",
  "/controllo/produzione": "Report produzione",
  "/controllo/qualita": "Report qualità",
  "/controllo/prezzi": "Prezzi di vendita ordini cliente",
};

const PREFIX_TITLES = [
  ["/semilavorati/cartellino", "Cartellino di stoccaggio"],
  ["/acquisti/ordini", "Scheda ordine di acquisto"],
  ["/acquisti/fornitori", "Scheda fornitore"],
  ["/preventivi", "Scheda preventivo"],
  ["/ordini-cliente", "Scheda ordine cliente"],
  ["/commesse", "Scheda ordine cliente"],
  ["/progetti", "Scheda progetto"],
  ["/produzione/ordini", "Scheda ordine di produzione"],
  ["/consegne", "Consegne / DDT"],
  ["/clienti", "Clienti"],
  ["/componenti", "Scheda componente"],
  ["/pezzi", "Scheda componente"],
  ["/macchine/confronto", "Confronto macchine"],
  ["/macchine", "Scheda macchina"],
  ["/qualita/piani-controllo", "Piano di controllo"],
  ["/qualita/procedure", "Procedura qualità"],
  ["/qualita/controlli", "Controllo digitale"],
  ["/qualita/non-conformita", "Non conformità"],
  ["/qualita/azioni-correttive", "Azione correttiva 8D"],
  ["/materiali", "Scheda materiale"],
  ["/utensili", "Scheda utensile"],
];

const PLANNING_PREFIXES = ["/commesse", "/ordini-cliente", "/progetti", "/consegne", "/produzione", "/reparti", "/turni"];

/** Moduli di piano con i percorsi che governano: il primo che combacia vince (ordine significativo). */
export const MODULE_GATES = [
  { module: "amministrazione", label: "Amministrazione e controllo", prefixes: ["/sedi", "/clienti"] },
  { module: "logistica", label: "Logistica generale e utensili", prefixes: ["/quadro-utensili", "/utensili", "/attacchi-base", "/inventario", "/formati-grezzo", "/magazzini", "/movimenti", "/analisi", "/consumo-utensili", "/attrezzature-staffaggio", "/semilavorati"] },
  { module: "acquisti", label: "Acquisti e fornitori", prefixes: ["/acquisti"] },
  { module: "produzione", label: "Produzione", prefixes: ["/controllo/produzione", "/produzione", "/officina", "/macchine", "/reparti", "/turni", "/materiali", "/componenti", "/pezzi", "/commesse", "/ordini-cliente", "/progetti", "/consegne"] },
  { module: "qualita", label: "Qualità", prefixes: ["/qualita"] },
  { module: "preventivazione", label: "Preventivazione", prefixes: ["/preventivi"] },
  { module: "controllo_gestione", label: "Controllo di gestione", prefixes: ["/controllo"] },
];

const HOME_CANDIDATES = [
  { to: "/controllo/dashboard", permission: "controlling:view", module: "controllo_gestione" },
  { to: "/ordini-cliente", permission: "planning:view", module: "produzione" },
  { to: "/utensili", permission: "catalog:view", module: "logistica" },
  { to: "/quadro-utensili", permission: "dashboard:view", module: "logistica" },
];

/** Prima pagina disponibile dopo l'accesso, in base a permessi e moduli del piano. */
export function homePath(permissions = [], planModules = null) {
  const candidate = HOME_CANDIDATES.find((item) => permissions.includes(item.permission)
    && (!item.module || (planModules ? planModules.includes(item.module) : false)));
  return candidate ? candidate.to : "/impostazioni-utente";
}

export function pageTitle(pathname) {
  const navMatch = allNavItems.find((item) => item.to === pathname)?.label;
  if (navMatch) return navMatch;
  if (STATIC_TITLES[pathname]) return STATIC_TITLES[pathname];
  const prefixMatch = PREFIX_TITLES.find(([prefix]) => pathname.startsWith(prefix));
  return prefixMatch ? prefixMatch[1] : "Pagina non trovata";
}

export function pageEyebrow(pathname) {
  if (pathname.startsWith("/acquisti")) return "ACQUISTI & FORNITORI";
  if (pathname.startsWith("/controllo") || pathname.startsWith("/clienti") || pathname.startsWith("/sedi")) return "AMMINISTRAZIONE & CONTROLLO";
  if (pathname.startsWith("/preventivi")) return "PREVENTIVAZIONE / COMMERCIALE";
  return PLANNING_PREFIXES.some((prefix) => pathname.startsWith(prefix)) ? "PIANIFICAZIONE PRODUZIONE" : "PLM UTENSILI / OPERATIVO";
}
